export const addressTypes = Object.freeze([
  'PERMANENT',
  'PRESENT',
  'BUSINESS'
]);
